import { BETA_BY_ID } from '@/settings/subscription-settings/betas/betas.helpers';
import { hasBetaAccess, waitForBetaOptIns } from '@/settings/subscription-settings/betas/betas.utils';

const listenSignalsBeta = (BETA_BY_ID as Record<string, unknown>).vocSignals;

export function hasListenSignalsBetaAccess (): boolean {
    return hasBetaAccess(listenSignalsBeta);
}

export async function waitForListenSignalsBetaOptIns (): Promise<void> {
    await waitForBetaOptIns(listenSignalsBeta);
}
